import { CircleOffOutlineIcon } from './CircleOffOutlineIcon';

/**
 * author: Simran
 * id 5DC46127-B07A-4E2B-B3BA-A98C0D2942F4
 * name circle-off-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle-off-outline.svg
 * tags
 */
export const NullOffIcon = CircleOffOutlineIcon;
export default NullOffIcon